// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tiptap-emoji-native {
  display: inline-block;
  width: 1em;
  height: 1em;
  font-size: 1em;
  line-height: 1;
  vertical-align: -0.15em;
  user-select: none;
  pointer-events: none;
}

.sw-tooltip {
  position: fixed;
  transform: translate(-50%, 0);
  background-color: #1f2230;
  color: #fff;
  font-size: 12px;
  line-height: 1.35;
  border-radius: 6px;
  padding: 8px 10px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  min-width: 180px;
  max-width: 260px;
  white-space: normal;
  text-align: left;
  pointer-events: none;
  z-index: 99999;
}

.sw-tooltip--above {
  transform: translate(-50%, -100%);
}

.sw-tooltip--static {
  position: relative;
  display: inline-block;
  transform: none;
}

.sw-tooltip::after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
}

.sw-tooltip--below::after {
  top: -6px;
  border-color: transparent transparent #1f2230 transparent;
}

.sw-tooltip--above::after {
  bottom: -6px;
  border-color: #1f2230 transparent transparent transparent;
}

.sw-tooltip__description {
  display: block;
  font-weight: 600;
}

.sw-tooltip__time {
  display: block;
  margin-top: 2px;
  color: #d4d7f0;
  font-size: 11px;
}

.chip-tooltip-fade-enter-active,
.chip-tooltip-fade-leave-active,
.sw-tooltip-fade-enter-active,
.sw-tooltip-fade-leave-active {
  transition:
    opacity 0.15s ease,
    transform 0.15s ease;
}

.chip-tooltip-fade-enter-from,
.chip-tooltip-fade-leave-to,
.sw-tooltip-fade-enter-from,
.sw-tooltip-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, 6px);
}

.sw-tooltip--above.sw-tooltip-fade-enter-from,
.sw-tooltip--above.sw-tooltip-fade-leave-to {
  transform: translate(-50%, calc(-100% + 6px));
}

.page {
  background: #fff;
  margin: 30px auto;
  box-shadow: 5px 5px 10px #00000024;
  display: flex;
}

.left-page {
  border-right: 2px dashed #00000033;
}

.page > div {
  width: 50%;
  display: flex;
  justify-content: center;
}

.page:first-of-type .right-page :is(h3, .card-title),
.page:first-of-type .right-page .inline-title-editor {
  font-size: 5cqw;
  margin-top: 17cqw;
  text-align: center;
}

/* PDF generation fixes - override background positioning for better centering */
/* The background image has floral section at top and blue section at bottom */
/* Need to override background-position for PDF since 0 crops the bottom */
#full-size-content .page:first-of-type .right-page {
  /* Remove padding to ensure background covers the full area */
  padding: 0 !important;
  /* Override background-position to center the image properly in PDF */
  background-position: 0 !important;
  /* Ensure background covers the entire element */
  background-size: cover !important;
  /* Ensure no overflow clipping */
  overflow: hidden !important;
  /* Ensure box-sizing is correct */
  box-sizing: border-box !important;
}

/* Fix title overflow in PDF generation */
#full-size-content .page:first-of-type .right-page :is(h3, .card-title),
#full-size-content .page:first-of-type .right-page .card-title {
  /* Ensure title doesn't get cut off */
  overflow: visible !important;
  max-height: none !important;
  /* Make sure text wraps properly */
  word-wrap: break-word;
}

#full-size-content .page:first-of-type .right-page .inline-title-editor>* {
  overflow: visible !important;
  max-height: none !important;
}
`, "",{"version":3,"sources":["webpack://./front/src/styles/base_theme.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;;;EAIE;;wBAEsB;AACxB;;AAEA;;;;EAIE,UAAU;EACV,+BAA+B;AACjC;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF,8EAA8E;AAC9E,0EAA0E;AAC1E;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,qEAAqE;EACrE,iCAAiC;EACjC,gDAAgD;EAChD,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;EAC3B,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA,yCAAyC;AACzC;;EAEE,qCAAqC;EACrC,4BAA4B;EAC5B,2BAA2B;EAC3B,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B","sourcesContent":[".tiptap-emoji-native {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  font-size: 1em;\n  line-height: 1;\n  vertical-align: -0.15em;\n  user-select: none;\n  pointer-events: none;\n}\n\n.sw-tooltip {\n  position: fixed;\n  transform: translate(-50%, 0);\n  background-color: #1f2230;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1.35;\n  border-radius: 6px;\n  padding: 8px 10px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);\n  min-width: 180px;\n  max-width: 260px;\n  white-space: normal;\n  text-align: left;\n  pointer-events: none;\n  z-index: 99999;\n}\n\n.sw-tooltip--above {\n  transform: translate(-50%, -100%);\n}\n\n.sw-tooltip--static {\n  position: relative;\n  display: inline-block;\n  transform: none;\n}\n\n.sw-tooltip::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 6px;\n  border-style: solid;\n}\n\n.sw-tooltip--below::after {\n  top: -6px;\n  border-color: transparent transparent #1f2230 transparent;\n}\n\n.sw-tooltip--above::after {\n  bottom: -6px;\n  border-color: #1f2230 transparent transparent transparent;\n}\n\n.sw-tooltip__description {\n  display: block;\n  font-weight: 600;\n}\n\n.sw-tooltip__time {\n  display: block;\n  margin-top: 2px;\n  color: #d4d7f0;\n  font-size: 11px;\n}\n\n.chip-tooltip-fade-enter-active,\n.chip-tooltip-fade-leave-active,\n.sw-tooltip-fade-enter-active,\n.sw-tooltip-fade-leave-active {\n  transition:\n    opacity 0.15s ease,\n    transform 0.15s ease;\n}\n\n.chip-tooltip-fade-enter-from,\n.chip-tooltip-fade-leave-to,\n.sw-tooltip-fade-enter-from,\n.sw-tooltip-fade-leave-to {\n  opacity: 0;\n  transform: translate(-50%, 6px);\n}\n\n.sw-tooltip--above.sw-tooltip-fade-enter-from,\n.sw-tooltip--above.sw-tooltip-fade-leave-to {\n  transform: translate(-50%, calc(-100% + 6px));\n}\n\n.page {\n  background: #fff;\n  margin: 30px auto;\n  box-shadow: 5px 5px 10px #00000024;\n  display: flex;\n}\n\n.left-page {\n  border-right: 2px dashed #00000033;\n}\n\n.page > div {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n}\n\n.page:first-of-type .right-page :is(h3, .card-title),\n.page:first-of-type .right-page .inline-title-editor {\n  font-size: 5cqw;\n  margin-top: 17cqw;\n  text-align: center;\n}\n\n/* PDF generation fixes - override background positioning for better centering */\n/* The background image has floral section at top and blue section at bottom */\n/* Need to override background-position for PDF since 0 crops the bottom */\n#full-size-content .page:first-of-type .right-page {\n  /* Remove padding to ensure background covers the full area */\n  padding: 0 !important;\n  /* Override background-position to center the image properly in PDF */\n  background-position: 0 !important;\n  /* Ensure background covers the entire element */\n  background-size: cover !important;\n  /* Ensure no overflow clipping */\n  overflow: hidden !important;\n  /* Ensure box-sizing is correct */\n  box-sizing: border-box !important;\n}\n\n/* Fix title overflow in PDF generation */\n#full-size-content .page:first-of-type .right-page :is(h3, .card-title),\n#full-size-content .page:first-of-type .right-page .card-title {\n  /* Ensure title doesn't get cut off */\n  overflow: visible !important;\n  max-height: none !important;\n  /* Make sure text wraps properly */\n  word-wrap: break-word;\n}\n\n#full-size-content .page:first-of-type .right-page .inline-title-editor>* {\n  overflow: visible !important;\n  max-height: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
